import React from "react";
import styles from "./CustomStars.module.scss";

const CustomStars: React.FC<{
  opinionReview: number;
  numberOpinionReviews?: number;
}> = (props) => {
  const { opinionReview, numberOpinionReviews } = props;

  if (+opinionReview === 0) return null;
  return (
    <div className={styles.mainContainer}>
      <div className={styles.descriptionStars}>
        {Array(Math.ceil(opinionReview / 2))
          .fill(1)
          .map((_, index, array) => {
            if (array.length - 1 === index) {
              return (array.length - 1) % 2 === 0 &&
                Math.floor(opinionReview) !== 10 ? (
                <img
                  src="https://booking.availroom.com/v2/assets/icons/halfStar.svg"
                  alt="star"
                  key={index}
                />
              ) : (
                <img
                  src="https://booking.availroom.com/v2/assets/icons/star.svg"
                  alt="star"
                  key={index}
                />
              );
            }
            return (
              <img
                src="https://booking.availroom.com/v2/assets/icons/star.svg"
                alt="star"
                key={index}
              />
            );
          })}
        {Array(Math.floor(Math.abs(Math.ceil(opinionReview) - 10) / 2))
          .fill(1)
          .map((_, index) => (
            <img
              src="https://booking.availroom.com/v2/assets/icons/notFilledStar.svg"
              alt="star"
              key={index}
            />
          ))}
        <p>{numberOpinionReviews || opinionReview}</p>
      </div>
    </div>
  );
};

export default CustomStars;
